import { motion, AnimatePresence } from "framer-motion";
import { QRCodeSVG } from "qrcode.react";
import { Sparkles, ArrowRight, ExternalLink, Copy } from "lucide-react";
import { formatMXN } from "@/lib/api";
import { toast } from "sonner";

export default function QRReceiptModal({ open, sale, onNext }) {
  if (!open || !sale) return null;
  const url = `${window.location.origin}/receipt/${sale.id}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Liga copiada");
    } catch { toast.error("No se pudo copiar"); }
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-md flex items-center justify-center p-4"
        data-testid="qr-modal"
      >
        <motion.div
          initial={{ y: 30, opacity: 0, scale: 0.96 }}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: 30, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="relative w-full max-w-lg bg-[#0a0a0a] border border-white/10 rounded-3xl p-6 md:p-8 text-center"
        >
          <div className="chip mx-auto"><Sparkles size={12} className="text-[#ccff00]" /> Ticket digital listo</div>
          <h2 className="font-display text-3xl md:text-4xl tracking-tighter mt-3 leading-none">
            Que <span className="text-[#ccff00]">escanee</span> su nota
          </h2>
          <p className="text-white/60 text-sm mt-2">
            {sale.items.length} artículo{sale.items.length !== 1 ? "s" : ""} · <span className="text-white font-display text-lg">{formatMXN(sale.total_amount)}</span>
          </p>

          <div className="mt-6 flex justify-center">
            <div className="bg-white p-4 rounded-2xl" data-testid="qr-code">
              <QRCodeSVG value={url} size={240} level="M" includeMargin={false} />
            </div>
          </div>

          <div className="mt-4 flex items-center justify-center gap-2 font-mono text-[11px] text-white/50">
            <span className="truncate max-w-[240px]" data-testid="qr-url">{url}</span>
            <button onClick={copyLink} className="text-white/60 hover:text-white p-1" data-testid="qr-copy" title="Copiar liga"><Copy size={12} /></button>
            <a href={url} target="_blank" rel="noreferrer" className="text-white/60 hover:text-white p-1" data-testid="qr-open" title="Abrir en pestaña"><ExternalLink size={12} /></a>
          </div>

          <button
            onClick={onNext}
            className="mt-6 w-full py-4 rounded-2xl bg-[#7dff5a] hover:bg-[#9dff85] text-black font-display text-xl tracking-tighter flex items-center justify-center gap-2 shadow-[0_15px_40px_-15px_rgba(125,255,90,0.6)]"
            data-testid="qr-next"
          >
            Listo · Siguiente cliente <ArrowRight size={18} />
          </button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
